import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { fetchPages, fetchHeaderFooter, searchPages } from "../../actions";
import { fetchSponsors, sortByName } from "ActionsSponsors";
import { published } from "../../../polls/actions/live-qa";
import TableContent from "./tablecontent";
import ModalContent from "./modal";
import LocaleStrings from "Languages";

class Pages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      pageNumber: 1,
      executed: false,
      sort: "randomly",
    };
    this.state = { isOpen: false };
  }

  componentDidMount() {
    this.props.fetchPages(this.props.session);
    this.props.fetchHeaderFooter(this.props.session);
  }

  // togglee
  unpublishedPage = () => {
    this.props.published("unpublished");
  };

  // Fetch Published QA List
  publishedPage = () => {
    this.props.published("published");
  };

  // togglee end

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  handleSortByName = (ev) => {
    var sort = ev.target.value;
    var pageNumber = 1;

    if (sort == "az") {
      this.props.sortByName(this.props.session, sort);
    } else {
      this.props.fetchSponsors(this.props.session);
    }

    this.setState({ sort, pageNumber, search: "" });
  };

  handleSearch = (event) => {
    var search = event.target.value;
    // var search = value.pagetitle

    var pageNumber = 1;

    if (search == "") {
      this.props.fetchPages(this.props.session);
    } else {
      this.props.searchPages(this.props.session, search);
    }
    this.setState({ search, pageNumber, sort: "randomly" });
  };

  additionCallback = () => {
    // after update call this method with page no. as param, it will display as your current record
    this.paginationCallback(this.state.pageNumber);
  };

  render() {
    var { session, reset, selectPublishedType } = this.props;
    var sortBy = [
      { label: "Sort by Name: Randomly", value: "randomly" },
      { label: "Sort by Name: A-Z", value: "az" },
    ];

    let publishedStyle = "btn btn-custom-table-blue";
    let unpublishedStyle = "btn btn-custom-table-white";
    if (selectPublishedType && selectPublishedType.ispublished != "published") {
      publishedStyle = "btn btn-custom-table-white";
      unpublishedStyle = "btn btn-custom-table-blue";
    }

    let totalpublished = 0;
    let totalunpublished = 0;

    return (
      <div className="panel noborder-panel">
        <div className="content-header-bar">
          <div
            className="pull-left"
            style={{ paddingTop: 10, display: "flex" }}
          >
            <div
              className="btn-group mr-2"
              role="group"
              aria-label="First group"
            >
              <button
                type="button"
                className={publishedStyle}
                onClick={this.publishedPage}
              >
                {LocaleStrings.published} ( {totalpublished} )
              </button>
              <button
                type="button"
                className={unpublishedStyle}
                onClick={this.unpublishedPage}
              >
                {LocaleStrings.unpublished} ( {totalunpublished} )
              </button>
            </div>
          </div>
          <div className="pull-right" style={{ paddingTop: 10 }}>
            <ul className="header-buttons">
              <li>
                <input
                  className="form-control mapsearches content-table-header-searchinput"
                  placeholder="Search"
                  type="text"
                  value={this.state.search}
                  onChange={this.handleSearch}
                />
              </li>
              <li className="schedule-button">
                <select
                  className="form-control dropdown-height-border content-table-header-selectrandomly"
                  placeholder="Sort by name"
                  value={this.state.sort}
                >
                  {sortBy.map((object, index) => {
                    return (
                      <option
                        key={`${object.value}-${index}`}
                        value={object.value}
                      >
                        {object.label}
                      </option>
                    );
                  })}
                </select>
              </li>
              <li>
                <ModalContent />
              </li>
            </ul>
          </div>
        </div>

        <div className="panel-body ">
          <TableContent />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    websitePages: state.websitePages,
    selectPublishedType: state.selectPublishedType,
    headerFooter: state.headerFooter,
  };
}

export default connect(mapStateToProps, {
  fetchPages,
  searchPages,
  fetchHeaderFooter,
  fetchSponsors,
  sortByName,
  published,
})(Pages);
